/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ActionListOperandValueImpl } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/ActionListOperandValueImpl";
import { AbstractOperandExpressionNodeConverter } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/converter/AbstractOperandExpressionNodeConverter";
import { OperatorOperandExpressionNodeConverter } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/converter/OperatorOperandExpressionNodeConverter";
import { ExpExpressionNodeNodeTypeEnum } from "abweb/generated/abwebinternal/api/dto/ExpExpressionNode";
import { Assert } from "abweb/utils/Assert";
import Immutable from "immutable";
export class ActionListOperandExpressionNodeConverter extends AbstractOperandExpressionNodeConverter {
  constructor(specification) {
    super(specification);
  }
  convert(expExpressionNode) {
    Assert.assert(expExpressionNode.nodeType === ExpExpressionNodeNodeTypeEnum.ACTION_LIST);
    return new ActionListOperandValueImpl(this.getStateWithoutNodeType(expExpressionNode));
  }
  getStateWithoutNodeType(expExpressionNode) {
    const operandValuesByNodeId = new Map();
    const converter = new OperatorOperandExpressionNodeConverter(this.specification);
    for (const childExpExpressionNode of expExpressionNode.operandValues ?? []) {
      operandValuesByNodeId.set(childExpExpressionNode.id, converter.convert(childExpExpressionNode));
    }
    return {
      ...super.getStateWithoutNodeType(expExpressionNode),
      operandValuesByNodeId: Immutable.OrderedMap(operandValuesByNodeId)
    };
  }
}
//# sourceMappingURL=ActionListOperandExpressionNodeConverter.js.map
